var cilToggleOn = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M368,128H144a128,128,0,0,0,0,256H368a128,128,0,0,0,0-256Zm0,224H144a96,96,0,0,1,0-192H368a96,96,0,0,1,0,192Z' class='ci-primary'/><path fill='var(--ci-primary-color, currentColor)' d='M368,192a64,64,0,1,0,64,64A64.072,64.072,0,0,0,368,192Zm0,96a32,32,0,1,1,32-32A32.036,32.036,0,0,1,368,288Z' class='ci-primary'/>"];

export { cilToggleOn };

